import { useState, useEffect, useCallback } from "react";

// react-router components
import { useLocation, Link, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components

import TextField from "@mui/material/TextField";
import { FaSearch } from "react-icons/fa";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

import MDButton from "components/MDButton";

import MDAvatar from "components/MDAvatar";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import menuicon3 from "assets/images/hamburger.png";
import colors from "assets/theme-dark/base/colors";
import MDTypography from "components/MDTypography";
import { useMediaQuery } from "react-responsive";
import { getUserInfo } from "services/apiService";
import { CircularProgress, InputAdornment } from "@mui/material";
import WalletDialog from "layouts/dialogModals/WalletDialog";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import MDBadge from "components/MDBadge";
import { getNotificationsCountData } from "services/apiService";
import metamaskSvg from "assets/images/metamask-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { getUserAppInfo } from "Store/slices/userInfoSlice";
import { getUserList } from "services/apiService";

import { getUserAppNotificationCount } from "Store/slices/Sugg&NotificationSlice";
import { getListCampaigns } from "services/apiService";
import { campaignReducer } from "Store/slices/campaignSlice";
import { connectWallet } from "Store/slices/walletSlice";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function DashboardNavbar({ absolute, light, isMini }) {
  const dispatch = useDispatch();
  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  const { campaignList, campaignLoading, campaignPageNumber } = useSelector(
    (state) => state.campaigns
  );

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const { userAppNotificationCount } = useSelector(
    (state) => state.userSuggestionAndNotifications
  );

  const { balanceReward, isRewardLoading } = useSelector(
    (state) => state.userRewards
  );

  const { isWeb3Enabled, address, chainId, balance, isWalletLoading } =
    useSelector((state) => state.walletData);

  let navigate = useNavigate();
  let location = useLocation();
  const { background } = colors;

  // const [navbarType, setNavbarType] = useState();
  // const [controller, dispatch] = useMaterialUIController();
  // const {
  //   miniSidenav,
  //   transparentNavbar,
  //   fixedNavbar,
  //   openConfigurator,
  //   darkMode,
  // } = controller;

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const route = useLocation().pathname.split("/").slice(1);

  const [searchTerm, setSearchTerm] = useState("");

  const [walletDialogBoolean, setWalletDialogBoolean] = useState(false);

  const [userInfo, setUserInfo] = useState("");

  const [notificationCount, setNotificationCount] = useState(0);

  const [error, setError] = useState();

  const handleConnectWallet = (providerApi) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (address === "") {
      dispatch(connectWallet(providerApi));
    } else {
      setWalletDialogBoolean(true);
    }
  };

  // useEffect(() => {
  //   // Setting the navbar type
  //   if (fixedNavbar) {
  //     setNavbarType("sticky");
  //   } else {
  //     setNavbarType("static");
  //   }

  //   // A function that sets the transparent state of the navbar.
  //   function handleTransparentNavbar() {
  //     setTransparentNavbar(
  //       dispatch,
  //       (fixedNavbar && window.scrollY === 0) || !fixedNavbar
  //     );
  //   }

  //   /**
  //    The event listener that's calling the handleTransparentNavbar function when
  //    scrolling the window.
  //   */
  //   window.addEventListener("scroll", handleTransparentNavbar);

  //   // Call the handleTransparentNavbar function to set the state with the initial value.
  //   handleTransparentNavbar();

  //   // Remove event listener on cleanup
  //   return () => window.removeEventListener("scroll", handleTransparentNavbar);
  // }, [dispatch, fixedNavbar]);

  // const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  // const handleConfiguratorOpen = () =>
  //   setOpenConfigurator(dispatch, !openConfigurator);
  // const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  // const handleCloseMenu = () => setOpenMenu(false);

  const handleNavigate = (name) => {
    if (name === "profile" || name === "settings") {
      if (!loginStatus) {
        console.log("test", name);
        dispatch(loginDialogReducer(true));
        return;
      }
    }

    if (name === "profile") {
      navigate(`/profile/?username=${localStorage.userNameSingh}`);
    } else if (name === "campaign") {
      navigate("/campaigns");
    } else if (name === "settings") {
      if (location.pathname === "/settings") {
        navigate(-1);
      } else {
        navigate("/settings");
      }
    } else {
      localStorage.removeItem("userNameSingh");
      localStorage.removeItem("jwtTokenSingh");
      // localStorage.clear();
      navigate("/sign-in");
    }
  };

  const handleNavSearch = () => {
    navigate(`/search`);
  };

  const handleNotifications = () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    navigate(`/notifications`);
  };

  // const handleChats = () => {
  //   navigate(`/chats`);
  // };

  const handleCloseWalletDialog = () => {
    setWalletDialogBoolean(false);
  };

  return (
    <>
      <AppBar
        // position={absolute ? "absolute" : navbarType}
        position="sticky"
        sx={{ backgroundColor: "#000" }}
        // sx={(theme) =>
        //   navbar(theme, { transparentNavbar, absolute, light, darkMode })
        // }
      >
        <Toolbar
          sx={{
            paddingLeft: "0px",
            paddingRight: "0px !important",
            marginLeft: isDesktopOrLaptop && "-24px",
          }}
        >
          <MDBox sx={{ width: "100%" }}>
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                justifyContent: "space-between",
              }}
            >
              {isTabletOrMobile ? (
                <>
                  <MDAvatar
                    src={userAppInfo?.profilePic}
                    alt="profile-image"
                    size="md"
                    shadow="sm"
                    imgProps={{ style: { height: "100%", width: "100%" } }}
                  />
                  <IconButton
                    onClick={() => handleNavigate("settings")}
                    sx={{
                      navbarIconButton,
                      marginLeft: "-35px",
                      marginBottom: "-15px",
                      fontSize: "25px",
                    }}
                  >
                    {/* <MenuIcon style={{ color: "black",
                backgroundColor:"#fff",
                borderRadius:"18px"
                 }} /> */}
                    <img
                      src={menuicon3}
                      style={{
                        objectFit: "contain",
                        color: "black",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                      }}
                      height="20px"
                      alt="menu"
                    />
                  </IconButton>
                  <MDTypography
                    fontSize="inherit"
                    sx={{
                      color: "#F5D243",
                      fontWeight: "bold",
                      marginLeft: "70px",
                    }}
                  >
                    SINGH APP
                  </MDTypography>
                  <IconButton
                    sx={{
                      navbarIconButton,
                      marginLeft: "auto",
                      fontSize: "28px",
                    }}
                    onClick={() => handleNavSearch()}
                  >
                    <FaSearch style={{ color: "grey" }} />
                  </IconButton>
                  <IconButton
                    sx={{
                      border: "1px solid #F2CB2E",
                      // margin: 0,
                      // padding: 0,
                      height: "40px",
                      width: "40px",
                    }}
                    onClick={() => handleNotifications()}
                  >
                    <MDTypography lineHeight="0px">
                      <MDBadge
                        badgeContent={userAppNotificationCount}
                        color="warning"
                        circular={true}
                        size="xs"
                      >
                        <NotificationsNoneIcon />
                      </MDBadge>
                    </MDTypography>
                  </IconButton>
                </>
              ) : (
                <>
                  <MDBox sx={{ width: "700px" }}>
                    <TextField
                      fullWidth
                      sx={{
                        paddingLeft: "0px",
                        // border: "1px solid red",
                      }}
                      InputLabelProps={{ shrink: false }}
                      label="...... Search here"
                      variant="outlined"
                      placeholder="Search"
                      value={searchTerm}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MDTypography color="text">
                              <FaSearch />
                            </MDTypography>
                          </InputAdornment>
                        ),
                      }}
                      // onChange={(e) => handleSearch(e.target.value)}
                      onClick={() => handleNavSearch()}
                    />
                  </MDBox>
                  <MDBox sx={{ width: "100px" }}>
                    <MDButton
                      fullWidth
                      color="singh"
                      variant="outlined"
                      startIcon={
                        <img
                          src={singhCoinCurrency}
                          style={{ objectFit: "contain" }}
                          height="20px"
                          alt="currentSymbol"
                        />
                      }
                    >
                      <MDTypography fontSize="inherit" color="inherit">
                        {isRewardLoading ? (
                          <CircularProgress size={15} color="inherit" />
                        ) : balanceReward !== 0 ? (
                          Number(balanceReward).toFixed(2)
                        ) : (
                          balanceReward
                        )}

                        {/* {reward.rewardInSingh != null
                          ? Number(reward.rewardInSingh).toFixed(2)
                          : reward} */}
                      </MDTypography>
                    </MDButton>
                  </MDBox>
                  <MDBox sx={{ width: "160px" }}>
                    <MDButton
                      fullWidth
                      color="singh"
                      variant="outlined"
                      startIcon={
                        <img
                          src={metamaskSvg}
                          style={{ objectFit: "contain" }}
                          height="15px"
                          alt="currentSymbol"
                        />
                      }
                      onClick={() => handleConnectWallet("ethereum")}
                    >
                      <MDTypography fontSize="inherit" color="inherit">
                        {isWalletLoading ? (
                          <CircularProgress size={15} color="inherit" />
                        ) : isWeb3Enabled ? (
                          Number(balance).toFixed(2)
                        ) : (
                          "Connect Wallet"
                        )}
                        {/* {isWeb3Enabled && address && balance !== undefined
                          ? Number(balance).toFixed(2)
                          : "Connect Wallet"} */}
                      </MDTypography>
                    </MDButton>
                  </MDBox>
                  {/* <IconButton
                    sx={{
                      border: "1px solid #F2CB2E",
                      // margin: 0,
                      // padding: 0,
                      height: "40px",
                      width: "40px",
                    }}
                    onClick={() => handleChats()}
                  >
                    <MDTypography lineHeight="0px">
                      <ChatIcon />
                    </MDTypography>
                  </IconButton> */}
                  <IconButton
                    sx={{
                      border: "1px solid #F2CB2E",
                      // margin: 0,
                      // padding: 0,
                      height: "40px",
                      width: "40px",
                    }}
                    onClick={() => handleNotifications()}
                  >
                    <MDTypography lineHeight="0px" color="singh">
                      <MDBadge
                        badgeContent={userAppNotificationCount}
                        color="warning"
                        circular={true}
                        size="xs"
                      >
                        <NotificationsNoneIcon color="inherit" />
                      </MDBadge>
                    </MDTypography>
                  </IconButton>
                </>
              )}

              {/* {renderMenu()} */}
            </MDBox>

            {walletDialogBoolean && (
              <WalletDialog
                openStatus={walletDialogBoolean}
                onClose={() => handleCloseWalletDialog()}
                // postId={postId}
                // type={type}
              />
            )}
          </MDBox>
        </Toolbar>
      </AppBar>
    </>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
